import { ACTIVE, INACTIVE, NEEDS_REVIEW } from 'AccountsApp/ts/constants/integrations.constants';
import { OrionIntegrationService } from 'IntegrationsApp/ts/services/orion-integration-service';
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "IntegrationsApp/ts/services/orion-integration-service";
import * as i2 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i3 from "NewAngular/features/directives/image/image.directive";
import * as i4 from "../integration-status-indicator/integration-status-indicator.component";
const _c0 = ["orionDeactivateModalComponent"];
const _c1 = ["orionActivateModalComponent"];
const _c2 = ["ycn-orion-integration-list-item", ""];
export class OrionIntegrationListItemComponent {
    constructor(orionIntegrationService) {
        this.orionIntegrationService = orionIntegrationService;
        this.status = '';
        this.errorMessage = '';
        this.innerHtml = '<p><strong>To connect your Orion integration to YCharts, log in to your Orion account.</strong></p>\n' +
            '<p>Once you log into your Orion account from this portal, you’ll return to YCharts and be able to import holdings from Orion.</p>';
    }
    ngOnInit() {
        this.updateStatus();
    }
    updateStatus() {
        this.orionIntegrationService.getOrionIntegrationStatus().subscribe({
            next: (data) => {
                if (data.isActive) {
                    this.status = ACTIVE;
                }
                else if (!data.isActive && data.errorMessage === null) {
                    this.status = INACTIVE;
                }
                else if (!data.isActive && data.errorMessage !== null) {
                    this.status = NEEDS_REVIEW;
                    this.errorMessage = data.errorMessage;
                }
            },
            error: () => { },
        });
    }
    activateHandler(confirmed) {
        if (confirmed) {
            window.location.href = `${this.authUrl}?response_type=code&redirect_uri=${this.redirectUri}&client_id=${this.clientId}`;
        }
        else {
            this.status = INACTIVE;
        }
    }
    deactivateHandler(confirmed) {
        if (confirmed) {
            this.orionIntegrationService.deactivateOrionIntegration().subscribe((res) => {
                if (res.status === 200) {
                    this.updateStatus();
                }
            });
        }
    }
    activateToggle() {
        if (this.status === ACTIVE) {
            this.orionDeactivateModalComponent.openModal();
        }
        else {
            this.status = ACTIVE;
            this.orionActivateModalComponent.openModal();
        }
    }
}
OrionIntegrationListItemComponent.ɵfac = function OrionIntegrationListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || OrionIntegrationListItemComponent)(i0.ɵɵdirectiveInject(i1.OrionIntegrationService)); };
OrionIntegrationListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OrionIntegrationListItemComponent, selectors: [["tr", "ycn-orion-integration-list-item", ""]], viewQuery: function OrionIntegrationListItemComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.orionDeactivateModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.orionActivateModalComponent = _t.first);
    } }, inputs: { clientId: "clientId", authUrl: "authUrl", redirectUri: "redirectUri" }, standalone: false, attrs: _c2, decls: 17, vars: 10, consts: [["orionActivateModalComponent", ""], ["orionDeactivateModalComponent", ""], [1, "table-logo"], ["ycnImage", "", 3, "imageSrc"], [1, "text-bold"], [3, "errorMessage", "status"], [1, "text-right"], [1, "custom-control", "custom-switch"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "checked"], [1, "custom-control-indicator"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"]], template: function OrionIntegrationListItemComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "td")(1, "div", 2);
        i0.ɵɵelement(2, "img", 3);
        i0.ɵɵelementStart(3, "div", 4);
        i0.ɵɵtext(4, "Orion");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(5, "td");
        i0.ɵɵtext(6, "Portfolio Holdings");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "td");
        i0.ɵɵelement(8, "ycn-integration-status-indicator", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "td", 6)(10, "label", 7)(11, "input", 8);
        i0.ɵɵlistener("change", function OrionIntegrationListItemComponent_Template_input_change_11_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.activateToggle()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(12, "span", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "ycn-confirm-modal", 10, 0);
        i0.ɵɵlistener("confirmHandler", function OrionIntegrationListItemComponent_Template_ycn_confirm_modal_confirmHandler_13_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.activateHandler($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "ycn-confirm-modal", 10, 1);
        i0.ɵɵlistener("confirmHandler", function OrionIntegrationListItemComponent_Template_ycn_confirm_modal_confirmHandler_15_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.deactivateHandler($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("imageSrc", "integrations/images/orion-logo.png");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("errorMessage", ctx.errorMessage)("status", ctx.status);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("checked", ctx.status === "active");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("confirmButtonText", "Log in to Orion")("confirmHeader", "Activate Orion Integration")("confirmText", ctx.innerHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("confirmButtonText", "Deactivate")("confirmHeader", "Deactivate Orion Integration")("confirmText", "Are you sure you would like to deactivate your integration with Orion? You will not be able to use this integration unless you reactivate it.");
    } }, dependencies: [i2.ConfirmModalComponent, i3.ImageDirective, i4.IntegrationStatusIndicatorComponent], encapsulation: 2 });
